export const environment = {
  "production": false,
  "api": {
    "identity": "",
    "backend": ""
  },
  "appName": "Master Schedule",
  "version": "1.0.0"
};
